require('./myProfileEditShippingAddressStep1.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

//@commons
const { FormattedText } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const { HireContactDataForm } = require('components/hireContactDataForm/hireContactDataForm');

// @utilities
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname');

class MyProfileEditShippingAddressStep1 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isModified: false,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { immProfileShippingAddress } = nextProps;

        let stateUpdates = null;

        if (!prevState.isModified && !immProfileShippingAddress.get('hasShippingAddress')) {
            stateUpdates = {
                isModified: true,
            };
        }

        return stateUpdates;
    }

    componentDidUpdate() {
        const {
            immProfileShippingAddress,
            scrollToTopToggle,
        } = this.props;

        if (immProfileShippingAddress.getIn(['steps', 0, 'scrollToTop'])) {
            if (this.scrollToError()) {
                scrollToTopToggle(false);
            }
        }
    }

    scrollToError() {
        const element = document.querySelector('.wizard__header');

        if (!!element) {
            window.scrollTo(0, element.offsetTop + 300);
        }

        return element;
    }

    buildFormError() {
        const {
            immHireContactData,
            immProfileShippingAddress,
        } = this.props;
        let hasEditError = false;
        let hasAddError = false;
        let errorMessage;

        if (!immProfileShippingAddress.getIn(['steps', 0, 'valid'])) {
            if (immProfileShippingAddress.get('hasShippingAddress')) {
                hasEditError = immHireContactData.get('isDirty');
            } else {
                hasAddError = this.state.isModified;
            }
        }

        if (hasAddError || hasEditError) {
            errorMessage = (
                <div className="profile-edit-shipping-address-step-1__message-wrapper">
                    <OKMessage
                        id="profile-edit-shipping-address-warning-message"
                        type="warning"
                    >
                        <FormattedText value="profileEditShippingAddress-profileEditShippingAddress_warningMessage" />
                    </OKMessage>
                </div>
            );
        }

        return errorMessage;
    }

    render() {
        const {
            immHireContactData,
            immProfileShippingAddress,
            isDeletePrintMode,
        } = this.props;
        const formError = this.buildFormError();
        const titleClass = conditionalClassName('', 'profile-edit-shipping-address-step-1__title--cc', 'profile-edit-shipping-address-step-1__title');

        let title = 'profileEditShippingAddress-profileEditShippingAddress_editTitleStep1';

        if (!immProfileShippingAddress.get('hasShippingAddress')) {
            title = 'profileEditShippingAddress-profileEditShippingAddress_addTitleStep1';
        } else if (isDeletePrintMode) {
            title = 'profileEditShippingAddress-profileEditShippingAddress_deleteTitleStep1'
        }

        return (
            <div className="profile-edit-shipping-address-step-1">
                <FormattedText
                    className={titleClass}
                    value={title}
                />
                <div className="profile-edit-shipping-address-step-1__message-wrapper">
                    <OKMessage type="informative">
                        <FormattedText value="profileEditShippingAddress-profileEditShippingAddress_updateAddressMessage"/>
                    </OKMessage>
                </div>
                {formError}
                <HireContactDataForm
                    immHireContactData={immHireContactData}
                    prepopulate={false}
                    showMobileDataForm={false}
                    showSubHeader={false}
                />
            </div>
        );
    }

}

MyProfileEditShippingAddressStep1.defaultProps = {
    isDeletePrintMode: false,
    scrollToTopToggle: () => {},
};

MyProfileEditShippingAddressStep1.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immProfileShippingAddress: PropTypes.object.isRequired,
    isDeletePrintMode: PropTypes.bool,
    scrollToTopToggle: PropTypes.func,
};

module.exports = MyProfileEditShippingAddressStep1;